import React, { useMemo, useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentBlockLoading } from 'components/ContentBlock'
import Button from 'components/Button'
import DxDataTable from 'components/DxDataTable'
import { columnsShopStatistic } from '../tableColumns'
import getListClosingsShopStatistics from '../gql/getListClosingsShopStatistics'
import { useQuery } from '@apollo/client'
import {
	generateDynamicCurrencyHeaders,
	generateDynamicDoubleHeaders,
	generateDynamicHeaders
} from '../utils'
import { useLazyQuery } from '../../../components/graphql'
import ProfileSettings from 'components/ProfileSettings/ProfileSettings'
import { Container } from '../styled'
import { filterReducer } from '../../statistics/pages/filterFragments'
import getMainCurrency from '../gql/getMainCurrency'
import get from 'lodash/get'

const ShopStatistic = ({ data, period, cashRegisterIds, ...rest }) => {
	const [t] = useTranslation()
	const result = useQuery(getMainCurrency, { fetchPolicy: 'cache-only' })
	const mainCurrency = get(result, 'data.cashAssist.getAppConfig.mainCurrency')
	const { cashRegisterId, dateTime } = data
	const { data: dataStatistic, loading } = useQuery(getListClosingsShopStatistics,
		{ variables: { filter: {
			cashRegisterIds: [cashRegisterId],
			period: { from: dateTime, to: dateTime }
		} } })
	const [settingsData, dispatchSettingsData] = useReducer(filterReducer, {
		savedSettings: {},
		profiles: [],
		value: null
	})
	const dataTable = dataStatistic?.cashAssist?.listClosingsShopStatistics[0]

	const [loadTotal, { data: dataTotalStatistic, loading: totalLoading }] = useLazyQuery(getListClosingsShopStatistics, { variables: { filter: {
		cashRegisterIds: cashRegisterIds || [],
		period: { from: period.from, to: period.to }
	} } })
	const tableColumns = useMemo(() => columnsShopStatistic({ t },
		generateDynamicDoubleHeaders(dataTable, 'taxes', t, 'sales', 'MWSt', 'closing_section.fields.sales', 'closing_section.fields.vat', true),
		generateDynamicDoubleHeaders(dataTable, 'paymentMethods', t, 'count', 'amount', 'common.fields.number', 'closing_section.fields.sales'),
		generateDynamicHeaders(dataTable, 'coupons', t, 'amount', 'closing_section.fields.sales'),
		generateDynamicHeaders(dataTable, 'specialSales', t, 'amount', 'closing_section.fields.sales', true, ['Kundenkredite']),
		generateDynamicCurrencyHeaders(dataTable, 'currency', t, 'amountConverted', 'present', 'difference', 'closing_section.fields.amount_converted', 'closing_section.fields.currency_present', 'closing_section.fields.difference_in', mainCurrency)
	), [dataStatistic])
	return (
		<ContentBlockLoading isLoading={ loading || totalLoading }>
			<Container>
				<Button
					text={t('closing_section.strings.billitem_total_amount')}
					onClick={loadTotal}
				/>
				<ProfileSettings onSelectProfile={dispatchSettingsData} profileData={settingsData} nameLocalStorage={'closingsStatisticsProfiles'} />
			</Container>
			{!loading && <DxDataTable
				data={dataTotalStatistic?.listClosingsShopStatistics || [dataTable]}
				columns={tableColumns}
				height={508}
				withSearch={false}
				settings={settingsData.savedSettings}
				customStoring
				onSaveSettings={(value) => dispatchSettingsData({ type: 'savedSettings', value })}
				excelExport
			/>}
		</ContentBlockLoading>
	)
}

export default ShopStatistic
